import { useMutation } from '@tanstack/react-query'
import { CreateCreativeParams, createCreative } from 'supabase/creatives'
import { queryClient } from 'utils'

export const useCreateCreative = (
  onSuccess: (created: { id: string; title: string | null }) => any
) => {
  const mutation = useMutation({
    mutationFn: (creative: CreateCreativeParams) => {
      return createCreative(creative)
    },
    onSuccess: (data: any, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['creatives'],
      })

      if (data && data.id) {
        onSuccess({ id: data.id, title: data.title })
      } else {
        onSuccess(data)
      }
    },
  })

  return mutation
}